<template>
  <!-- dialogType:
  1.领取福利
  2.已经获得福利一共四种子情况，获取代金券或vip X 有渠道包或者无渠道包
  3. 已经激活过该福利
  4. 活动说明
   -->
  <h1>服务已下线</h1>
  <!-- <div class="benefit-container" >
    <div class="page__bg"></div>
    <div class="background-image">
      <div class="co-and-activity-intro-container">
        <div class="co">
          <img  src="~assets/benefit/xl-icon.jpg" class="xl-icon"/>
          <img src="~assets/benefit/and@3x.png" class="and" v-if="fromIconUrl"/>
          <img class="from-icon" :src="fromIconUrl" v-if="fromIconUrl">
        </div>
        <div class="activity-intro" @click="showActivityIntroDialog = true">
          <span class="label">活动说明</span>
          <img class="icon" src="~/assets/benefit/activity-intro.png" alt="label">
        </div>
      </div>
      <div class="mask" v-show="showAnyDialog" ></div>
      <div class="button" @click="handleShowDialog" :class="pageType"></div>
      <span class="monopolization" v-if="cooperationApp">{{cooperationApp}}用户专享</span>


      <receive-benefit :visible="showReceiveDialog" :from="from" ></receive-benefit>
      <received-benefit :visible="showReceivedDialog"  :download-url="downloadUrl" :from="from"></received-benefit>
      <activity-intro :visible="showActivityIntroDialog" :valid-days="validDays" :vip-days="vipDays" :voucher-amount="voucherAmount"></activity-intro>
      <has-activated :visible="showHasActivitedDialog"></has-activated>
    </div>
  </div> -->
</template>

<script>
import ReceiveBenefit from './receiveBenefit'
import ReceivedBenefit from './receivedBenefit'
import HasActivated from './hasActivated'
import ActivityIntro from './activityIntro'
import eventHub from './eventHub'
import { ScaleEle } from './scaleEle'
import api from '@/components/api/benefit'
import { stat } from './stat'
export default {
  head () {
    return {
      title: '迅雷会员限时福利'
    }
  },
  components: {
    ReceiveBenefit,
    ReceivedBenefit,
    HasActivated,
    ActivityIntro
  },
  data() {
    return {
      showReceiveDialog: false,
      showReceivedDialog: false,
      showHasActivitedDialog: false,
      showActivityIntroDialog: false,
      fromInfo: Object.create(null)
    }
  },
  methods: {
    handleShowDialog() {
      if (this.fromInfo.constructor) {
        this.showReceiveDialog = true
      }
    },
    ChangeDialogVisible(type, state, next) {
      switch (type) {
        case 1:
          this.showReceiveDialog = state
          if (state === false)  {
            eventHub.$emit('clearForm')
          }
          break
        case 2:
          this.showReceivedDialog = state
          break
        case 3:
          this.showHasActivitedDialog = state
          break
        case 4:
          this.showActivityIntroDialog = state
          break
      }
    }
  },
  computed: {
    showAnyDialog() {
      return (
        this.showReceiveDialog ||
        this.showActivityIntroDialog ||
        this.showHasActivitedDialog ||
        this.showReceivedDialog
      )
    },
    pageType() {
      return this.$route.query.type || 'receive'
    },
    from() {
      return this.$route.query.from || '*'
    },
    cooperationApp() {
      return this.fromInfo['cooperationApp'] || ''
    },
    fromIconUrl() {
      return this.fromInfo['appIconUrl'] || ''
    },
    downloadUrl() {
      return this.fromInfo['downloadUrl'] || ''
    },
    validDays() {
      return this.fromInfo['validDays'] || 1
    },
    vipDays () {
      return this.fromInfo['vipDays'] || 1
    },
    voucherAmount () {
      return this.fromInfo['voucherAmount'] || 1
    }
  },
  created() {
    eventHub.$on('update:visible', this.ChangeDialogVisible)
  },
  beforeDestroy() {
    eventHub.$off('update:visible', this.ChangeDialogVisible)
  },
  mounted() {
    // stat('event', 'page_show', { from: this.from })
    // api.getBenefitConfiguration().then(data => {
    //   if (data.data) {
    //     data.data.some(item => {
    //       if (item.from === this.from) {
    //         this.fromInfo = item
    //         return true
    //       }
    //     })
    //   }
    // })
    // const inner = new ScaleEle({
    //   select: '.background-image',
    //   width: 360,
    //   height: 640,
    //   mode: 'contain',
    //   position: 'center'
    // })

    // const bg = new ScaleEle({
    //   select: '.page__bg',
    //   width: 360,
    //   height: 640,
    //   mode: 'cover',
    //   position: 'center'
    // })
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
:root {
  --psd: 360;
  --rfz: 100;
}

html {
  font-size: calc(100vw / var(--psd) * var(--rfz));
}

@media screen and (min-width: 1080px) {
  html {
    font-size: 100px;
  }
  body {
    width: 1080px;
  }
}
body {
  max-width: 1080px;
  margin: 0 auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  margin: 0;
}
a {
  cursor: pointer;
}
/*no*/
.benefit-title {
  font-weight: 400;
  font-size: 18px; /*no*/
  color: #262a2f;
  text-align: center;
  line-height: 25px; /*no*/
  margin: 0;
  margin-top: 40px; /*no*/
}

.benefit-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  .page__bg,
  .background-image {
    position: absolute;
    width: 360px; /*no*/
    height: 640px; /*no*/
    top: 50%;
    left: 50%;
    margin: -320px 0 0 -180px; /*no*/
  }
  .page__bg {
    background-image: url('~assets/benefit/bg.jpg');
  }

  .background-image {
    background-size: contain;
    position: relative;
    background-repeat: no-repeat;
    background-image: url('~assets/benefit/background.png');
    .button {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background-size: contain;
      background-repeat: no-repeat;
      width: 132px; /*no*/
      height: 36px; /*no*/
      top: 442px; /*no*/
      background-image: url('~assets/benefit/receive.png');

      &.active {
        background-image: url('~assets/benefit/active.png');
      }
    }
    .monopolization {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      // width: 132px; /*no*/
      // height: 36px; /*no*/
      // top: 407.666px; /*no*/
      bottom: 231px; /*no*/
      font-size: 12px; /*no*/
      color: #ffe34b;
      letter-spacing: 0.8px; /*no*/
      text-shadow: 0 0.666px 1.333px rgba(6, 7, 60, 0.26); /*no*/
    }
    .co-and-activity-intro-container {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 1;
      height: 40px; /*no*/
      width: calc(100% - 16px); /*no*/
      left: 8px; /*no*/
      top: 20px; /*no*/
      .activity-intro {
        display: flex;
        .label {
          font-size: 12px; /*no*/
          color: #ffffff;
        }
        .icon {
          width: 16px; /*no*/
          height: 16px; /*no*/
        }
      }
      .co {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 91.333px; /*no*/
        opacity: 0.7;
        background: #001239;
        border-radius: 4px; /*no*/
        border-radius: 4px; /*no*/
        .xl-icon,
        .from-icon {
          height: 31.666px; /*no*/
          width: 31.666px; /*no*/
          background-size: contain;
          border-radius: 3.5567px; /*no*/
        }
        .and {
          background-size: contain;
          margin: 0 1.166px; /*no*/
          width: 17.443px; /*no*/
          height: 17.443px; /*no*/
        }
      }
    }
    .mask {
      position: absolute;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.6;
      background: #000;
    }
  }
}
</style>
